import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/**
 * Lopettia-flavored Textarea — same dark card surface and teal-glow focus as
 * Input, sized for multi-line composition (feed posts, chat, auto-replies).
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-[6px] border border-[var(--color-lop-border)] bg-[var(--color-lop-bg-card)] px-3 py-2 text-sm text-[var(--color-lop-text-primary)] transition-colors',
          'placeholder:text-[var(--color-lop-text-dim)]',
          'focus-visible:outline-none focus-visible:border-[var(--color-lop-teal)] focus-visible:bg-[var(--color-lop-bg-card-hi)] focus-visible:shadow-[0_0_0_3px_var(--color-lop-teal-glow)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';
